// Seconds between healthcheck endpoint pings
export const HEALTHCHECK_INTERVAL = 20_000
